<script setup lang="ts">
/**
 * Top bar: the only spinner in the product. Hidden when nothing runs — and equally hidden
 * when the view it reads did not count running work at all (`null`), because an unread
 * figure is not a zero and must never be drawn as one.
 */
defineProps<{ running: number | null }>()
</script>

<template>
  <button v-if="running !== null && running > 0" type="button" class="num inline-flex h-7 items-center gap-1.5 rounded-[var(--radius-control)] border border-border px-2.5 text-[length:var(--type-meta)] font-medium hover:bg-muted whitespace-nowrap shrink-0">
    <span class="size-[var(--measure-11px)] animate-spin rounded-full border-[var(--measure-1p5px)] border-border border-t-info shadow-glow-info" />
    {{ running }} running
  </button>
</template>
